export default "__VITE_ASSET__DAttTYN0__"